// extracted by mini-css-extract-plugin
export default {"tagGroup":"styles_tagGroup__2u3sZ","label":"styles_label__Waqrx","group":"styles_group__-mqfO","tag":"styles_tag__HTcXp"};